import { IResolutionDisplayProps } from "../types/interfaces/IResolutionDisplayProps";
import { Box, Link, Typography } from '@mui/material';
import ParseHTML from "../../global/components/ParseHTML";

//This component is responsible for rendering the name and resolved text of the chosen resolution.
//Props: The IResolution object is passed in from the caller.
const ResolutionDisplay: React.FC<IResolutionDisplayProps> = ({ selectedResolution }) => {
    return (
        <>
            <Typography variant="h5" component="div" sx={{ paddingTop: 2 }}>
                <Box sx={{ fontWeight: 'bold' }}>{selectedResolution?.Name}</Box>
            </Typography>
            <Typography variant="h6" color="primary.dark" component="div">
                <Box sx={{ fontWeight: 'bold' }}>Resolve</Box>
            </Typography>
            <Typography variant="body1" component="div">
                {ParseHTML(selectedResolution?.ResolvedText!)}
            </Typography>
            <Link
                href={selectedResolution?.Link!} 
                underline="hover"
                color="primary.dark"
                target="_blank" 
                rel="noopener" >
                {selectedResolution?.Link!}
            </Link>
        </>
    );
}

export default ResolutionDisplay;